// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2SE-d","insightsList":"newBusinessInsightsMenu_insightsList__1z_R5","active":"newBusinessInsightsMenu_active__2ncX1"};